<p-toast position="bottom-right" />
<!-- Tabla Principal: SERVICIOS DE LA OPERACION Y HBL NÚMERO-->
<!-- <h2>{{titleTable1}}</h2>
<app-a-table
  [dataTable]="serviciosAdicionalesDt"
  [metadataTable]="mtServiciosAdicionalesTable"
  editMode="row"
  editChildrenMode="cell"
  [funcionalButtons]="rowFunctions">
</app-a-table> -->

<!-- Tabla Réplica: SERVICIOS DE LA PROFORMA -->
<h2>{{titleTable2}}</h2>
<div style="position: relative;">
  <div *ngIf="loadingServicios" class="loading-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <app-a-table
    [dataTable]="serviciosAdicionalesDt"
    [metadataTable]="mtServiciosAdicionalesTable" [styleRow]="styleRow"
    [checkInicial]="false"
    [estadoCheckCabecera]="todosEstanSeleccionados"
    (dataTableChange)="serviciosAdicionalesDt = $event">
  </app-a-table>
</div>
<!-- Estamos sobre un dialog -->
<!-- BOTON GUARDAR (BASE DE DATOS), ENVIAR CORREO (SOLO CUANDO YA HAYA GUARDADO LA PROFORMA), botón para CERRAR DIALOG -->
<div class="dialog-footer mt-4">
  <!-- Botón GUARDAR -->
  <button
    pButton
    type="button"

    [label]="!haySeleccionadosParaGuardar ? 'Debe seleccionar uno para guardar' : (guardado ? 'Actualizar' : 'Guardar')"

    icon="pi pi-save"

    [class]="haySeleccionadosParaGuardar ? 'p-button-success' : 'p-button-secondary'"

    (click)="guardarServicios()"

    [disabled]="!haySeleccionadosParaGuardar || (guardado && !hayCambiosPendientes())"
  ></button>

  <!-- Botón ENVIAR CORREO (solo visible si ya se guardó la proforma) -->
  <button
    pButton
    type="button"
    [label]="hayCambiosPendientes() ? 'Guarde cambios para preparar correo' : 'Preparar Correo'"
    icon="pi pi-envelope"
    [class]="hayCambiosPendientes() ? 'p-button-warning' : 'p-button-info'"
    (click)="abrirDialogCorreo()"
    [disabled]="!puedePrepararCorreo"
  ></button>

  <!-- Botón CERRAR -->
  <button
    pButton
    type="button"
    label="Cerrar"
    icon="pi pi-times"
    class="p-button-secondary"
    (click)="onCerrar()"
  ></button>
</div>


<p-dialog header="Enviar Correo Proforma" [(visible)]="verDocCorreo"
  [style]="{width: '90vw', height: '85vh'}"
  appendTo="body" [maximizable]="true" [closable]="true">

  <p-toast position="bottom-right" key="correo"></p-toast>

  <form [formGroup]="groupCorreo">

    <p-floatlabel class="w-full mb-4 mt-4">
      <label for="mailOrigen">De</label>
      <input pInputText formControlName="mailOrigen" id="mailOrigen" type="text" class="p-inputtext-sm w-full" />
    </p-floatlabel>

    <p-floatlabel class="w-full mb-4">
      <label for="mailTo">Para</label>
      <input pInputText formControlName="mailTo" id="mailTo" type="text" class="p-inputtext-sm w-full" />
    </p-floatlabel>

    <p-floatlabel class="w-full mb-4">
      <label for="mailCc">CC</label>
      <input pInputText formControlName="mailCc" id="mailCc" type="text" class="p-inputtext-sm w-full" />
    </p-floatlabel>

    <p-floatlabel class="w-full mb-4">
      <label for="mailBcc">CCO</label>
      <input pInputText formControlName="mailBcc" id="mailBcc" type="text" class="p-inputtext-sm w-full" />
    </p-floatlabel>

    <p-floatlabel class="w-full mb-4">
      <label for="subject">Asunto</label>
      <input pInputText formControlName="subject" id="subject" type="text" class="p-inputtext-sm w-full" />
    </p-floatlabel>

    <div style="margin-top: 1%; position: relative;">
      <div *ngIf="loadingEditor" class="loading-overlay">
        <p-progressSpinner></p-progressSpinner>
      </div>

      <smart-editor #editor id="editor" [toolbarItems]="toolbarItems"
                    style="width:100%; height: 50vh;"
                    [ngClass]="{'hidden-editor': loadingEditor}">
      </smart-editor>
    </div>

    <div class="mt-4 flex justify-content-center gap-3">
      <p-button label="ENVIAR CORREO" icon="pi pi-send"
        (onClick)="enviarCorreoSolicitudDocumentos()"
        [loading]="loadingEnvCorreo"
        [disabled]="!correoValid()">
      </p-button>

      <p-button label="SALIR" icon="pi pi-times"
        class="p-button-secondary"
        (onClick)="manejoPopUpCorreoSolicitudDocumentos('C')">
      </p-button>
    </div>

  </form>
</p-dialog>
